import React from "react";
import { IDocument, IVehicle } from "dataModels/contract";
import VehicleDataInfo from "./vehicleDataInfo";
import { FormMode, VehicleType, DocumentType, DsLayout } from "shared/constants";
import SimpleTable, { SimpleTableType } from "components/SimpleTable";
import { useTranslation } from "react-i18next";
import { 
    IFileInputConfig, 
    getVehicleFileInputConfig,
    EntityType, 
    DATE_FORMAT, 
    Affirmation 
} from "shared/constants";
import {v4 as uuid} from "uuid";
import _ from "lodash";
import moment from "moment";
import "views/contractView/styles/contractDataStyles.css";//to be replaced with its own one
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";
import DsHorizontalDivider from "components/DsHorizontalDivider";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import { Table } from "@ds/ds-snam/react";
import { ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { fileCategories } from "./vehicleData";
import { getDSTableSharedElements, getTableCellsHeaderSimple } from "shared/utils/dsComponentUtils";

interface IVehicleFormReviewProps{
    formData: IVehicle,
    formMode: FormMode
}
const VehicleFormReview:React.FC<IVehicleFormReviewProps> = (props)=>{
    const {formData, formMode} = props;
    const {t} = useTranslation(['contract', 'app']);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const tableContainerStyle = { borderRadius: "12px", background: layoutMode===DsLayout.DARK_MODE?"#04122a":"var(--Neutrali-0, #FFF)", padding: "12px", marginTop: "12px" };

    const tableColumns = (() => {
        //return ["Tipologia documento", "Nome File", "Data fine validità"]
        return t("vehicle.vehicleForm.sections.review.fileTable.tableColumns", { ns: 'contract', returnObjects: true }) as string[];
    })();

    const parseDocTypeLabel = (type: string) => {
        const typeMap: Record<string, string> = {
            [DocumentType.REGISTRATION_DOCUMENT]: t('vehicle.vehicleForm.sections.fileInput.title.0'),
            [DocumentType.TECHNICAL_CHECK]: t('vehicle.vehicleForm.sections.fileInput.title.1'),
            [DocumentType.PID]: t('vehicle.vehicleForm.sections.fileInput.title.2'),
            [DocumentType.GA_DRAWING]: t('vehicle.vehicleForm.sections.fileInput.title.3'),
            [DocumentType.PROCEDURES]: t('vehicle.vehicleForm.sections.fileInput.title.4'),
            [DocumentType.INSURANCE_CERTIFICATE]: t('vehicle.vehicleForm.sections.fileInput.title.5'),
            [DocumentType.ADR_DECLARATION]: t('vehicle.vehicleForm.sections.fileInput.title.6'),
            [DocumentType.TEST_CERTIFICATE]: t('vehicle.vehicleForm.sections.fileInput.title.7'),
            [DocumentType.FLAME_ARREST]: t('vehicle.vehicleForm.sections.fileInput.title.8'),
        };
    
        return typeMap[type] || '';
    };
    const fileInputConfig: IFileInputConfig[] = getVehicleFileInputConfig(formData.type, formData.flameArrest);
    
    // DA QUI
        const getTableRowsByCategory = (categoryKey: keyof typeof fileCategories): ITableRow[] => {
            const files: { document: IDocument; label: string }[] = [];
            const selectedCategory = fileCategories[categoryKey];
        
            selectedCategory.forEach((category) => {
                let foundDocument = _.find(formData?.documents, { type: category?.type });
                if (foundDocument) {
                    files.push({
                        document: foundDocument,
                        label: t('vehicle.vehicleForm.sections.fileInput.title.' + category?.headerPosition),
                    });
                }
            });
        
            return files.map((fileObj) => ({
                tableCells: [
                    { type: 'text', text: parseDocTypeLabel(fileObj.document.type) },
                    { type: 'text', text: fileObj.document.name },
                    {
                        type: 'text',
                        text: fileObj.document.expire
                            ? parseDateForDS(
                                  moment.unix(fileObj.document.expire).format(DATE_FORMAT),
                                  IParseDateFormatType.DATE_FORMAT1
                              )
                            : '',
                    },
                ],
            }));
        };
        
        const getTableRowsDoc = (): ITableRow[] => getTableRowsByCategory("documents");
        const getTableRowsCertifications = (): ITableRow[] => getTableRowsByCategory("certifications");
        const getTableRowsProcedures = (): ITableRow[] => getTableRowsByCategory("procedures");
        //A QUI

        const myTableConfigDoc: ITableConfig = {
            ...getDSTableSharedElements(),
            tableHeader: {
                tableCellsHeader: [
                    getTableCellsHeaderSimple(t("vehicle.vehicleForm.sections.review.fileTable.tableColumns.0", { ns: 'contract' }) as string,"col1","34%","left"),
                    getTableCellsHeaderSimple(t("vehicle.vehicleForm.sections.review.fileTable.tableColumns.1", { ns: 'contract' }) as string,"col2","33%","left"),
                    getTableCellsHeaderSimple(t("vehicle.vehicleForm.sections.review.fileTable.tableColumns.2", { ns: 'contract' }) as string,"col3","33%","left")
                ]
            },
            tableRows: getTableRowsDoc()
        };
        const myTableConfigCertifications: ITableConfig = {
            ...getDSTableSharedElements(),
            tableHeader: {
                
                tableCellsHeader: [
                    getTableCellsHeaderSimple(t("vehicle.vehicleForm.sections.review.fileTable.tableColumns.0", { ns: 'contract' }) as string,"col1","34%","left"),
                    getTableCellsHeaderSimple(t("vehicle.vehicleForm.sections.review.fileTable.tableColumns.1", { ns: 'contract' }) as string,"col2","33%","left"),
                    getTableCellsHeaderSimple(t("vehicle.vehicleForm.sections.review.fileTable.tableColumns.2", { ns: 'contract' }) as string,"col3","33%","left")
                ]
            },
            tableRows: getTableRowsCertifications()
        };   
        const myTableConfigProcedures: ITableConfig = {
            ...getDSTableSharedElements(),
            tableHeader: {
                
                tableCellsHeader: [
                    getTableCellsHeaderSimple(t("vehicle.vehicleForm.sections.review.fileTable.tableColumns.0", { ns: 'contract' }) as string,"col1","34%","left"),
                    getTableCellsHeaderSimple(t("vehicle.vehicleForm.sections.review.fileTable.tableColumns.1", { ns: 'contract' }) as string,"col2","33%","left"),
                    getTableCellsHeaderSimple(t("vehicle.vehicleForm.sections.review.fileTable.tableColumns.2", { ns: 'contract' }) as string,"col3","33%","left")
                ]
            },
            tableRows: getTableRowsProcedures()
        };
    return <>
        <VehicleDataInfo vehicle={formData} excludeFields={[]} isData={false}/>
        <DsHorizontalDivider/>
        {formMode === FormMode.NEW && <div>
            <p className="documentTableTitle--contract">
                {/*Documenti*/}
                {t('vehicle.vehicleForm.sections.review.fileTable.title.0')}
            </p>
            {/*<div style={tableContainerStyle}>
                <SimpleTable
                    columns={tableColumns}
                    rows={tableRows(2)}
                />
            </div>*/}
            {
                <Table 
                    tableConfig={myTableConfigDoc} 
                />
            }              
        </div>}
        <DsHorizontalDivider/>
        {formMode === FormMode.NEW && (formData.type===VehicleType.TANKER||formData.type===VehicleType.ISO_CONTAINER) && <div>
            <p className="documentTableTitle--contract">
                {/*Procedure*/}
                {t('vehicle.vehicleForm.sections.review.fileTable.title.1')}
            </p>
            {/*<div style={tableContainerStyle}>
            <SimpleTable
                columns={tableColumns}
                rows={tableRows(3)}
            /></div>*/}
            {
                <Table 
                    tableConfig={myTableConfigProcedures} 
                />  
            }
        </div>}
        <DsHorizontalDivider/>
        {formMode === FormMode.NEW && <div>
            <p className="documentTableTitle--contract">
                {/*Certificazioni*/}
                {t('vehicle.vehicleForm.sections.review.fileTable.title.2')}
            </p>
            {/*<div style={tableContainerStyle}>
            <SimpleTable
                columns={tableColumns}
                rows={tableRows(4)}
            /></div>*/}
            {
                <Table 
                    tableConfig={myTableConfigCertifications} 
                />
            }
        </div>
        }
    </>
}
export default VehicleFormReview;